module.exports = __webpack_public_path__ + "static/media/One_Day_Workshop_mr.03722a84.jpg";